import React from 'react';
import styled from 'styled-components';
import { ForecastCardTitleHourDay } from '../styles';
import { IForecastCard } from './types';

type ForecastCardTitleHourProps = Pick<IForecastCard, 'hour'>;

export const ForecastCardTitleHour = ({ hour }: ForecastCardTitleHourProps) => {
    return (
        <ForecastCardTitleHourDay textColor='#666'>
            {hour}
        </ForecastCardTitleHourDay>
    );
};